import React from "react";

// Define sender constants that determine "sent" styling
// 'bot' will now also use "sent" styling but with a different green.
const SENDER_STYLE_AS_SENT_BY_ME = ['human_operator', 'bot'];

// Function to get a display-friendly label for the sender
const getSenderLabel = (sender) => {
  switch (sender) {
    case 'human_operator':
      return 'Humain';
    case 'bot': // Changed from 'ai_agent' to 'bot'
      return 'Agent IA';
    case 'customer':
    case 'user':
      return 'Lead';
    default:
      return sender ? sender.charAt(0).toUpperCase() + sender.slice(1) : '';
  }
};

const MessageBubble = ({ message, sender, timestamp }) => {
  const useSentMessageStyle = SENDER_STYLE_AS_SENT_BY_ME.includes(sender);
  const labelText = getSenderLabel(sender);

  // Determine background color based on sender
  let backgroundColor = "#fff"; // Default for received messages
  if (sender === 'human_operator') {
    backgroundColor = "#d9fdd3"; // Standard green for human operator
  } else if (sender === 'bot') {
    backgroundColor = "#e6ffde"; // Lighter green for bot messages
  }

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: useSentMessageStyle ? "flex-end" : "flex-start",
      margin: '4px 16px',
      marginBottom: '10px', // Increased bottom margin slightly for label visibility
    }}>
      {/* Message Content Bubble */}
      <div style={{
        backgroundColor: backgroundColor, // Apply dynamic background color
        borderRadius: useSentMessageStyle ? "12px 12px 0 12px" : "12px 12px 12px 0",
        padding: '8px 12px',
        maxWidth: '70%',
        boxShadow: '0 1px 1px rgba(0,0,0,0.1)', // Slightly increased shadow for better depth
        wordWrap: 'break-word',
      }}>
        <p style={{ margin: 0, whiteSpace: 'pre-wrap', color: '#333' }}>{message || ''}</p> {/* Ensured text color for readability */}
        <span style={{
          fontSize: '10px',
          color: '#555', // Slightly darker timestamp for better contrast
          display: 'block',
          textAlign: 'right',
          marginTop: '4px',
        }}>
          {timestamp ? new Date(timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : ''}
        </span>
      </div>

      {/* Sender Label */}
      {labelText && (
        <span style={{
          fontSize: '11px', // Slightly larger font for label
          color: '#777',   // Slightly darker grey for better visibility
          marginTop: '3px', // Adjusted space
          paddingRight: useSentMessageStyle ? '10px' : '0',
          paddingLeft: !useSentMessageStyle ? '10px' : '0',
          alignSelf: useSentMessageStyle ? 'flex-end' : 'flex-start',
        }}>
          {labelText}
        </span>
      )}
    </div>
  );
};

export default MessageBubble;
